export default "__VITE_ASSET__8443e822__"